<template>
  <div class="menu-item" @click="($event) => onItemClicked()">
    <IconLockMask :icon-locked="item.iconLocked" :icon="item.icon" :is-locked="needLocked" />
    <p>
      {{ item.name }}
    </p>
  </div>
</template>

<script lang="ts" setup>
  import { computed, ref } from 'vue'
  import { debounce } from 'lodash'
  import type { BaseAppInfo } from '@core/application/ApplicationManager'
  import { TimeConstants } from '@core/Constants'
  import useValidateClient from '@core/compositions/HeytapAccount'
  import useAppSwitch from '@core/compositions/UseAppSwitcher'
  import IconLockMask from './IconLockMask.vue'

  const props = defineProps<{
    item: BaseAppInfo
    isTrustedClient: boolean
  }>()

  const needLocked = computed(() => !props.isTrustedClient && props.item.needClientValidation)

  const emit = defineEmits<{
    (e: 'on-click', app: BaseAppInfo): void
  }>()

  const switchMicroApp = (item: BaseAppInfo) => {
    emit('on-click', item)

    window.location.replace(item.entry)
  }

  const { switchApp } = useAppSwitch()

  const onItemClicked = debounce(
    () => {
      switchApp(onLockedAddSwitchApp)
    },
    TimeConstants.FASTER_DEBOUNCING_IN_MS,
    { leading: true, trailing: false }
  )

  const onLockedAddSwitchApp = async () => {
    if (needLocked.value) {
      return await useValidateClient(() => switchMicroApp(props.item))
    }

    return switchMicroApp(props.item)
  }
</script>

<style lang="stylus" scoped>

  .menu-item
    & > p
      title(default_font_weight)
      margin-top 6px
      text-align center
      font-size 12px
      max-width 60px
      ellipsis()
</style>
